import type { FC } from 'react';

import { useContent } from '@eneco/cms';
import { Box, Stack, Text } from '@eneco/sparky';

import type { TextStreamerContent } from './text-streamer-content.types';

/**
 * `TextStreamer` block for the CMS-agnostic lane, serving **both** providers.
 *
 * Mirrors the legacy Sitecore lane
 * (`libs/sitecore/components/content/src/TextStreamer/TextStreamer.tsx`): an optional quote-styled
 * title and an optional sub-text below it, both with fixed sizing. The legacy component declares
 * `headingLevel`/`headingSize` rendering parameters (`libs/sitecore/types/TextStreamer.d.ts`) but never
 * actually reads them, so this mirrors that unused-params behavior rather than wiring up new behavior —
 * see `text-streamer-content.types.ts`. Drops the legacy `wrap()` calls — this lane never runs inside
 * the Sitecore Experience Editor.
 */
const TextStreamer: FC = () => {
  const content = useContent<TextStreamerContent>();

  return (
    <Box paddingTop="10" paddingBottom="6">
      <Stack gap="5">
        {content.title && (
          <Text size={{ initial: 'QuoteS', md: 'QuoteM' }} color="textBrand" weight="regular">
            {content.title}
          </Text>
        )}
        {content.streamerSubText && (
          <Text size={{ initial: 'BodyM', md: 'BodyL' }} color="textLowEmphasis">
            {content.streamerSubText}
          </Text>
        )}
      </Stack>
    </Box>
  );
};

export default TextStreamer;
